import { Stack, useTheme } from '@mui/material';

interface props {
  height?: number;
  message?: string;
  dataNotFound?: string;
}

const DataNotFound = ({ height, message, dataNotFound }: props) => {
  const theme = useTheme();
  return (
    <>
      <Stack gap={-1}>
        <img
          src={
            'https://firebasestorage.googleapis.com/v0/b/syncglob-833e6.firebasestorage.app/o/dataNotFound.png?alt=media&token=4c387fdb-d02d-4df0-8319-2b2bc37b8d1f'
          }
          style={{
            objectFit: 'contain',
            height,
            width: '100%',
          }}
        />
        <Stack fontSize="24px" textAlign="center" fontWeight={600}>
          {dataNotFound}
        </Stack>
        <Stack
          fontSize="12px"
          color={theme.palette.grey[600]}
          justifyContent={'center'}
          alignSelf={'center'}
        >
          {message}
        </Stack>
      </Stack>
    </>
  );
};
export { DataNotFound };
